import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { colors } from "../../../../libs";

export const ModalWrapper = styled(Modal)`
  .modal-content {
    background: ${colors.background.black};
    border-radius: 10px;
    width: 100vw; /* Full viewport width */
    height: 100vh; /* Full viewport height */
    max-width: none; /* Override Bootstrap restrictions */
    max-height: none; /* Override Bootstrap restrictions */
    display: flex;
    flex-direction: column;
    position:fixed;
    overflow: auto; 
  }
`;
